import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import StudentList, { DispatchProps, OwnProps, StateProps } from './StudentList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getStudents, getStudentsCsv } from 'src/store/actions/student-actions';
import { getInvoicesCsv } from '../../../../../../store/actions/invoice-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.students.data,
        inProgress: state.students.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getStudents(params)),
        getDataCsv: (params: QueryParams) => dispatch(getStudentsCsv(params)),
    };
}

const StudentListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(StudentList);

export default StudentListScreen;
